<template>
  <b-modal ref="appConfirmationModal" :title=title ok-title="Bestätigen" cancel-title="Abbrechen" v-on:ok="confirm">
    <div v-html="message"></div>
  </b-modal>
</template>

<script>
export default {
  name: 'ConfirmModal',

  data () {
    return {
      title: '',
      message: '',
      confirmCallback: null
    }
  },

  destroyed () {
    this.$off('ok')
  },

  methods: {
    show (message, title = 'Bestätigen', confirmCallback = null) {
      this.message = message
      this.title = title
      this.confirmCallback = confirmCallback

      this.$refs.appConfirmationModal.show()
    },

    confirm () {
      if (this.confirmCallback instanceof Function) {
        this.confirmCallback()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/misc/ConfirmModal.vue